import React, { PureComponent } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { isNull } from 'lodash/fp';
import { isRecurringAssignment } from 'selectors/assign';
import DateFormat from 'constants/date_format';
import * as selectors from 'selectors/assign';
import Option from './SelectableItem.jsx';

class SchedulingOptions extends PureComponent {
  renderOption(label) {
    return <Option label={label} shrinked />;
  }

  render() {
    const dateFormat = DateFormat.SHORT;
    const { renderOption, props } = this;
    const {
      assignDate,
      dueDate,
      recurring,
      hasTrainingContent,
      hasJourneyContent,
    } = props;

    const showRecurring =
      (hasTrainingContent || (!hasTrainingContent && !hasJourneyContent)) &&
      recurring;

    return (
      <div className="AssignStep-selectedItems">
        {isNull(assignDate) &&
          renderOption(
            t('contents.assign_modal.scheduling.assign_immediately'),
          )}
        {assignDate &&
          renderOption(
            `${t(
              'contents.assign_modal.scheduling.assign_on_step_badge',
            )} ${moment(assignDate).format(dateFormat)}`,
          )}
        {dueDate &&
          renderOption(
            `${t('contents.assign_modal.scheduling.due_step_badge')} ${moment(
              dueDate,
            ).format(dateFormat)}`,
          )}
        {showRecurring &&
          renderOption(
            t(
              'contents.assign_modal.scheduling.recurring_assignment_step_badge',
            ),
          )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  assignDate: state.schedule.assignDate,
  dueDate: state.schedule.dueDate,
  hasTrainingContent: selectors.buildAssignment(state).content.length > 0,
  hasJourneyContent: selectors.buildJourneyAssignment(state).content.length > 0,
  recurring: isRecurringAssignment(state),
});

export default connect(mapStateToProps)(SchedulingOptions);
